import React from "react";
import {
  FaUserPlus,
  FaBook,
  FaLaptopCode,
  FaChartLine,
  FaBriefcase,
} from "react-icons/fa";
import "./OverviewSection.css";

const OverviewSection = () => {
  return (
    <section className="overview-section">
      <div className="overview-card">
        <div className="overview-header">
          <h2>About AAPS Placements</h2>
          <p>
            AAPS Placements provides industry-focused training with real-time
            projects and strong placement support.
          </p>
        </div>

        <div className="timeline">
          <div className="timeline-row right">
            <div className="content">
              <h4>01 Career Planning</h4>
              <p>
                Planning to build a career in IT? We help you find the right
                guidance and support system to achieve your goals.
              </p>
            </div>
            <div className="circle">
              <FaUserPlus />
            </div>
          </div>

          <div className="timeline-row left">
            <div className="circle">
              <FaBook />
            </div>
            <div className="content">
              <h4>02 Training</h4>
              <p>
                Complete software training with online & offline sessions
                aligned with industry standards.
              </p>
            </div>
          </div>

          <div className="timeline-row right">
            <div className="content">
              <h4>03 Practical</h4>
              <p>Live projects and hands-on experience.</p>
            </div>
            <div className="circle">
              <FaLaptopCode />
            </div>
          </div>

          <div className="timeline-row left">
            <div className="circle">
              <FaChartLine />
            </div>
            <div className="content">
              <h4>04 Evaluation</h4>
              <p>Tests and progress tracking.</p>
            </div>
          </div>

          <div className="timeline-row right">
            <div className="content">
              <h4>05 Career Support</h4>
              <p>Resume building, mock interviews & placements.</p>
            </div>
            <div className="circle">
              <FaBriefcase />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OverviewSection;
